import React from 'react';
import { useTranslation } from 'react-i18next';
import BaseModal from '@/modal/baseModal';
import Button from '@/ui-kit/Button';
import SubmitButton from '@/ui-kit/SubmitButton';
import styles from './styles.module.scss';

interface ExitConfirmationModalProps {
  onCancel: () => void;
  onConfirmExit: () => void;
}

const ExitConfirmationModal: React.FC<ExitConfirmationModalProps> = ({ onCancel, onConfirmExit }) => {
  const { t } = useTranslation();

  return (
    <BaseModal width='440px' hideCloseIcon={true}>
      <div className={styles.exitConfirmation__header}>
        <h6 className={styles.exitConfirmation__title}>{t('termsAndConditions.exitConfirmation.title')}</h6>
      </div>
      <div className={styles.exitConfirmation__body}>
        <p className={styles.exitConfirmation__message}>{t('termsAndConditions.exitConfirmation.message')}</p>
        <p className={styles.exitConfirmation__question}>{t('termsAndConditions.exitConfirmation.question')}</p>
      </div>
      <div className={styles.exitConfirmation__actions}>
        <Button id='cancelExitButton' label={t('termsAndConditions.exitConfirmation.cancelButton')} onClick={onCancel} />
        <SubmitButton
          id='confirmExitButton'
          label={t('termsAndConditions.exitConfirmation.exitButton')}
          onClick={onConfirmExit}
          inputStyle='w-max'
          paymentBtn={true}
        />
      </div>
    </BaseModal>
  );
};

export default ExitConfirmationModal;
